import path from 'path'

// Path utils
const PathAPI = {
  resolve (from, to) {
    if (typeof from !== 'string') throw new TypeError(`path 0 must be string, got ${typeof from}.`)
    if (typeof to !== 'string') throw new TypeError(`path 1 must be string, got ${typeof to}.`)
    from = from.trim()
    to = to.trim()
    return Path.normalize(
      path.join(from, Path.relative(from, to))
    )
  },

  relative (from, to) {
    if (typeof from !== 'string') throw new TypeError(`path 0 must be string, got ${typeof from}.`)
    if (typeof to !== 'string') throw new TypeError(`path 1 must be string, got ${typeof to}.`)
    from = from.trim()
    to = to.trim()
    return Path.normalize(
      path.relative(from, (
        path.isAbsolute(to)
          ? to
          : (path.isAbsolute(from)
            ? path.join(from, to)
            : to
          )
      ))
    )
  },

  normalize (p) {
    if (typeof p !== 'string') throw new TypeError(`path must be string, got ${typeof p}.`)
    p = p.trim()
    p = path.normalize(p)
    p = p.trim()
    if (p === '/') return '/'
    if (p === '.') return './'
    if (p === './') return './'
    if (p === '..') return '../'
    if (p === '../') return '../'
    if (p.endsWith('/')) p = p.slice(0, -1)
    if (path.isAbsolute(p)) return p
    if (!p.startsWith('./') && !p.startsWith('../')) return './' + p
    return p
  },

  contains (from, to) {
    return !Path.relative(from, to).startsWith('../')
  },

  dirname (p) {
    if (typeof p !== 'string') throw new TypeError(`path ${p} must be string, got ${typeof p}.`)
    p = p.trim()
    return Path.normalize(path.dirname(p))
  },

  join (...args) {
    args.forEach((arg, index) => {
      if (typeof arg !== 'string') throw new TypeError(`path ${index} must be string, got ${typeof arg}.`)
    })
    args = args.map(s => s.trim && s.trim())
    return Path.normalize(path.join(...args))
  },

  scope (root, path) {
    if (!Path.isAbsolute(root)) {
      throw new TypeError('root must be absolute.')
    }
    if (!Path.isAbsolute(path)) {
      throw new TypeError('path must be absolute.')
    }

    if (!Path.contains(root, path)) {
      // prevent access outside root
      throw new Error('path outside scope root.')
    }
    return Path.relative(root, path).slice(1) // remove leading dot from ./
  },

  descope (root, scopedPath = '/') {
    if (!Path.isAbsolute(root)) {
      throw new TypeError('root must be absolute.')
    }

    if (!Path.isAbsolute(scopedPath)) {
      throw new TypeError('scopedPath must be absolute.')
    }

    scopedPath = `.${scopedPath}` // add leading . to absolute scoped path
    const rawPath = Path.normalize(Path.join(root, scopedPath))
    if (!Path.contains(root, rawPath)) {
      // prevent access outside root
      throw new Error('path outside scope root.')
    }

    return rawPath
  }
}

const Path = Object.assign(Object.create(path), PathAPI)
export default Path

const { resolve, relative, normalize, contains, dirname, join, extname, basename, isAbsolute, parse, posix, scope, descope } = Path
export { resolve, relative, normalize, contains, dirname, join, extname, basename, isAbsolute, parse, posix, scope, descope }



// WEBPACK FOOTER //
// ../webmango-utils/path.js